import '../../../assets/styles/ErrorMessage.css';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import { useAudioVideo } from '../../../hooks/storeHooks/useSessionState';

export const ErrorMessage: React.FC = () => {
  const { t } = useTranslation();
  const { webRTCStatus } = useAudioVideo();

  const handleReload = () => window.location.reload();

  return (
    <div className="tc-mentor-waiting-wrapper">
      <div className="tc-mentor-waiting-container">
        <div className="tc-mentor-waiting-logo flex align-middle items-center !mb-8">
          <img
            src={'/assets/images/logo_napster_white.svg'}
            className="h-[26px]"
            alt="logo"
          />
        </div>
        <div className="tc-mentor-waiting-desc">{webRTCStatus?.message}</div>
        <div className="tc-mentor-waiting-buttons-container">
          {webRTCStatus?.btnType === 'home' ? (
            <Link to="/" className="btn btn-secondary mt-4 ">
              {t('generation.goHomeButton')}
            </Link>
          ) : (
            <button onClick={handleReload} className="btn btn-secondary mt-4 ">
              {t('common.tryAgain')}
            </button>
          )}
        </div>
        <div className="tc-mentor-waiting-log !text-black">
          {webRTCStatus?.reason}
        </div>
      </div>
    </div>
  );
};
